import * as React from 'react';
import { useRef } from 'react';
import SvgDeleteImageIcon from '../../assets/DeleteImageIcon';
import './ImageUploader.scss';

export type ImpageUploaderProps = {
  image: string;
  viewOnly: boolean;
  error?: boolean;
  onUpload: (newImage: File) => void;
  onDelete: () => void;
};

const ImageUploader = ({ image, onUpload, onDelete, viewOnly, error = false }) => {
  const fileInput = useRef<HTMLInputElement>(null);

  const handleFileChange = (e) => {
    let newImage = (e?.target?.files?.length > 0) ? e.target.files[0] : null;
    if (newImage) {
      onUpload(newImage);
    }
  };

  const handleFileRemove = () => {
    onDelete();
  };

  const handleFileModal = () => {
    // only allow upload option if there's no image currently (should delete current image first)
    if (fileInput && fileInput.current && (!image || image === '')) fileInput.current.click();
  };

  return (
    <div className="imageUploadContainer">
      <div className={`imageUploadArea ${error ? 'imageUploadError' : ''}`} onClick={handleFileModal}>
        {image && image !== '' ? (
          <div>
            <div onClick={handleFileRemove}>
              {!viewOnly && <SvgDeleteImageIcon className="deleteIcon" />}
            </div>
            <img src={image} alt="Upload" />
          </div>
        ) : (
          '+ Add Photos from Camera Roll'
        )}
      </div>
      <input
        ref={fileInput}
        type="file"
        accept="image/*"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default ImageUploader;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ImageUploader/index.tsx